// 首页展示配置模块上下文

import { createContext, useContext, ReactNode } from "react";
import { useHomeDisplayData } from "../stores";
import { homeDisplayService } from "../services";
import { useBaseCache } from "../../base/contexts";

// Context类型定义
interface HomeDisplayContextType {
  // 数据
  homeDisplayData: ReturnType<typeof useHomeDisplayData>;
  // 服务
  homeDisplayService: typeof homeDisplayService;
  // 基础缓存
  cache: ReturnType<typeof useBaseCache>;
}

// 创建Context
const HomeDisplayContext = createContext<HomeDisplayContextType | null>(null);

// Provider Props
interface HomeDisplayContextProviderProps {
  children: ReactNode;
}

// Provider组件
export function HomeDisplayContextProvider({
  children,
}: HomeDisplayContextProviderProps) {
  const homeDisplayData = useHomeDisplayData();
  const cache = useBaseCache();

  const value: HomeDisplayContextType = {
    homeDisplayData,
    homeDisplayService,
    cache,
  };

  return (
    <HomeDisplayContext.Provider value={value}>
      {children}
    </HomeDisplayContext.Provider>
  );
}

// Hook
export function useHomeDisplayContext(): HomeDisplayContextType {
  const context = useContext(HomeDisplayContext);
  if (!context) {
    throw new Error(
      "useHomeDisplayContext must be used within HomeDisplayContextProvider"
    );
  }
  return context;
}
